<template>
  <div>
    <div class="container-fluid mt-3">
      <b-row class="">
        <!--    <b-col>
          <h4 class="ml-3">Locations</h4>
        </b-col> -->
      </b-row>
      <div>
        <TableBase
          :items="locations.data"
          :fields="fields"
          :options="options"
          :busy="locations.status === 'fetching' ? true : false"
        >
          <template v-slot:rightSide>
            <div>
              <!--    <b-button
                v-if="userHasPermission('locations', 'write')"
                variant="success"
                class="align-bottom"
                @click="showModal()"
              >
                <b-icon icon="plus" class="mt-1" />
              </b-button> -->
            </div>
          </template>
          <template v-slot:extra-action>
            <div>
              <b-icon
                v-if="userHasPermission('locations', 'write')"
                icon="trash"
                class="cursor-pointer"
                @click="deleteItem(item)"
              ></b-icon>
            </div>
          </template>
        </TableBase>
      </div>

      <b-modal
        id="detailsModal"
        ref="detailsModal"
        size="lg"
        hide-footer
        body-class="pl-0 pr-0"
        ok-disabled
        @hidden="locationItem = {}"
      >
        <LocationRegistrationForm
          :locationItem="locationItem"
          :refreshData="getData"
          :hideModal="hideModal"
        />
      </b-modal>
    </div>
  </div>
</template>
<script>
import TableBase from "@/modules/shared/table.vue";
import LocationRegistrationForm from "./LocationRegistrationForm.vue";

import { GET_LOCATIONS, POST_LOCATION, DELETE_LOCATION } from "./actions";
import { mapState } from "vuex";

import { generalMixin } from "@/modules/mixin.js";
import { superAdminMixin } from "../mixins";
export default {
  name: "ExportLocationTable",
  components: { TableBase, LocationRegistrationForm },
  mixins: [generalMixin, superAdminMixin],
  computed: {
    ...mapState({
      locations: (state) => state.superAdminStore.location.locations,
    }),
    hasPermission() {
      return this.userHasPermission("locations", "write");
    },
    fields() {
      return [
        { key: "name", label: "Name" },
        { key: "street", label: "Street" },
        { key: "zip", label: "ZIP" },
        { key: "city", label: "City" },
        { key: "state", label: "State" },
        {
          key: "actions",
          label: "Actions",
          note: false,
          details: true,
          validation: false,
          delete: this.hasPermission,
          hardDelete: false,
        },
      ];
    },
  },
  data() {
    return {
      options: {
        assign: false,
        rolFilter: false,
        add: false,
        fun: this.getData,
      },
      locationItem: {},
    };
  },
  mounted() {
    this.$store.commit(
      "setAddFunction",
      this.userHasPermission("locations", "write") ? this.showModal : null
    );
    this.getData();
  },
  methods: {
    getData(filter = "") {
      const payload = {
        search: filter,
        status: 1,
      };
      if (this.$route.params.type === "company") {
        payload.companyId = this.$route.params.id;
      } else {
        payload.exportLocationId = this.$route.params.id;
      }
      this.$store
        .dispatch(GET_LOCATIONS, payload)
        .then(() => {})
        .catch(() => {});
    },
    async deleteItem(item) {
      const confirm = await this.showConfirmDeleteBox();
      if (!confirm) return;
      const payload = { ...item };
      this.$store
        .dispatch(DELETE_LOCATION, { id: payload.id })
        .then(() => {
          this.getData();
          this.makeToast("Success", "Fee updated successfully", "success");
        })
        .catch(() => {
          this.$root.$bvToast.toast("Fee could not be disabled", {
            title: "Error",
            variant: "warning",
          });
        });
    },
    activateItem(item) {
      const payload = {
        id: item.id,
        status: 1,
      };
      this.$store
        .dispatch(POST_LOCATION, payload)
        .then(() => {
          this.makeToast("Success", "Fee updated successfully", "success");
          this.getData();
        })
        .catch(() => {
          this.$root.$bvToast.toast("Fee could not be activated", {
            title: "Warning",
            variant: "warning",
          });
        });
    },
    showModal() {
      this.$bvModal.show("detailsModal");
    },
    editItem(item) {
      this.locationItem = item;
      this.$bvModal.show("detailsModal");
    },
    changePage(page, filter = "") {
      const payload = {
        search: filter,
        page: page,
        companyId: this.$route.params.id,
        status: 1,
      };
      this.$store
        .dispatch(GET_LOCATIONS, payload)
        .then(() => {})
        .catch(() => {
          this.$root.$bvToast.toast("error", {
            title: "Error",
            variant: "warning",
          });
        });
    },

    hideModal() {
      this.$bvModal.hide("detailsModal");
    },
  },
};
</script>
